module.exports = __webpack_public_path__ + "static/media/jetson_one_render_19.25eb40eb.jpg";